export const SUBMENU_COMPONENT_TYPE = 'wixui.Submenu'
